module.exports = "\n:host>>>table tr th a{\n  color: #1e6bb8 !important;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/Screens/new-user/new-user.component.css
// module id = ./src/app/Screens/new-user/new-user.component.css
// module chunks = main